import React, { useEffect, useRef } from 'react';
import { Brain, Eye, Repeat, Target } from 'lucide-react';
export function WhyItWorks() {
  const sectionRef = useRef<HTMLElement>(null);
  const hasTracked = useRef(false);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasTracked.current) {
          try {
            if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
              window.fbq('trackCustom', 'ViewWhyItWorksSection', {
                section: 'Why It Works'
              });
              console.log('✅ ViewWhyItWorksSection event tracked');
              hasTracked.current = true;
            }
          } catch (error) {
            console.error('❌ Error tracking why it works section:', error);
          }
        }
      });
    }, {
      threshold: 0.5
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-10 bg-white" id="por-que-funciona" data-id="element-567">
      <div className="container mx-auto px-4 md:px-6" data-id="element-568">
        <div className="max-w-3xl mx-auto" data-id="element-569">
          <h2 className="text-2xl md:text-3xl font-bold text-amber-900 mb-6 font-serif text-center" data-id="element-570">
            ¿Por qué funciona?
          </h2>
          <p className="text-amber-800 mb-8 text-center" data-id="element-571">
            Porque combina neurociencia infantil + disciplina positiva +
            herramientas visuales:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-572">
            <div className="bg-amber-50 p-5 rounded-lg border border-amber-100" data-id="element-573">
              <div className="flex items-center gap-3 mb-3" data-id="element-574">
                <div className="h-10 w-10 bg-amber-700 rounded-full flex items-center justify-center" data-id="element-575">
                  <Brain className="text-white" size={20} data-id="element-576" />
                </div>
                <h3 className="font-bold text-amber-900" data-id="element-577">
                  Cerebro en desarrollo
                </h3>
              </div>
              <p className="text-amber-800 text-sm" data-id="element-578">
                Los niños pequeños procesan mejor información visual que verbal
              </p>
            </div>
            <div className="bg-amber-50 p-5 rounded-lg border border-amber-100" data-id="element-579">
              <div className="flex items-center gap-3 mb-3" data-id="element-580">
                <div className="h-10 w-10 bg-amber-700 rounded-full flex items-center justify-center" data-id="element-581">
                  <Eye className="text-white" size={20} data-id="element-582" />
                </div>
                <h3 className="font-bold text-amber-900" data-id="element-583">Anticipación</h3>
              </div>
              <p className="text-amber-800 text-sm" data-id="element-584">
                Ver los pasos reduce ansiedad y resistencia
              </p>
            </div>
            <div className="bg-amber-50 p-5 rounded-lg border border-amber-100" data-id="element-585">
              <div className="flex items-center gap-3 mb-3" data-id="element-586">
                <div className="h-10 w-10 bg-amber-700 rounded-full flex items-center justify-center" data-id="element-587">
                  <Repeat className="text-white" size={20} data-id="element-588" />
                </div>
                <h3 className="font-bold text-amber-900" data-id="element-589">Consistencia</h3>
              </div>
              <p className="text-amber-800 text-sm" data-id="element-590">
                La misma secuencia diaria crea automatismos
              </p>
            </div>
            <div className="bg-amber-50 p-5 rounded-lg border border-amber-100" data-id="element-591">
              <div className="flex items-center gap-3 mb-3" data-id="element-592">
                <div className="h-10 w-10 bg-amber-700 rounded-full flex items-center justify-center" data-id="element-593">
                  <Target className="text-white" size={20} data-id="element-594" />
                </div>
                <h3 className="font-bold text-amber-900" data-id="element-595">Autonomía</h3>
              </div>
              <p className="text-amber-800 text-sm" data-id="element-596">
                El niño puede seguir los pasos solo, sin esperar órdenes
              </p>
            </div>
          </div>
          <div className="mt-8 bg-amber-100 border border-amber-200 rounded-lg p-5" data-id="element-597">
            <p className="text-amber-900 text-center font-medium" data-id="element-598">
              No es magia. Es ciencia aplicada + estrategia visual + límites
              amables.
            </p>
          </div>
        </div>
      </div>
    </section>;
}